import { useCometUserAuthenticationWebHandler_getUser } from '@zg-rentals/ts-capps-client-react-query';

export default function useGetUser() {
  return useCometUserAuthenticationWebHandler_getUser({ pageWithSensitiveInformation: true });
}
